function ValidateZipCode(rule: any, value: string, callback: any) {
    if (value != null && value.length > 0 && !/(^\d{5}$)|(^\d{5}-\d{4}$)/.test(value)) {
        callback('Not a valid Zip Code.');
    }
    callback();
}

export default ValidateZipCode;
